import {FCWithHTMLAttributes} from "../types/reactTypes";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/sharp-regular-svg-icons/faXmark";
import clsMerge from "../util/clsMerge";

type ModalBodyProps = {
	hasCloseButton?: boolean;
	onClose: () => void;
};

const ModalBody: FCWithHTMLAttributes<ModalBodyProps> = ({
	children,
	className,
	hasCloseButton = true,
	onClose,
	...props
}) => {
	return (
		<div className="max-h-full">
			<div
				className={clsMerge(
					"relative flex max-w-full flex-row bg-white px-4 py-10 md:px-10",
					className
				)}
				{...props}
			>
				{children}
				{hasCloseButton && (
					<div className="absolute right-4 top-4 text-2xl text-midtone-blue hover:text-navy-700 md:block">
						<button onClick={() => onClose()}>
							<FontAwesomeIcon icon={faXmark} />
						</button>
					</div>
				)}
			</div>
		</div>
	);
};

export default ModalBody;
